import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

type TabTitleProperties = {
  readonly isActive: boolean;
};

export const TabTitle = styled.span<TabTitleProperties>`
  text-overflow: ellipsis;
  padding: 12px 10px;
  display: block;
  border-bottom: 2px solid
    ${ifProp('isActive', palette('primary'), 'transparent')};

  cursor: pointer;
  margin-left: 6px;
`;

export const TabTitleContainer = styled.div`
  margin: 10px 0 0 0;
  display: flex;
  border-bottom: 1px solid ${palette('bgHoverGrey')};
`;
